export function createRecordFromKey<T, K extends keyof T, I extends keyof T>(
  items: T[],
  idKey: I,
  valueKey: K,
): Record<string, T[K]> {
  const record: Record<string, T[K]> = {};

  for (const item of items) {
    const id = (item[idKey] as any).toString();
    const value = item[valueKey];

    record[id] = value;
  }

  return record;
}

export function createRecordFromArray<T, K extends keyof T>(
  items: T[],
  idKey: K,
): Record<string, T> {
  const record: Record<string, T> = {};

  for (const item of items) {
    const id = (item[idKey] as any).toString();

    record[id] = item;
  }

  return record;
}

export function createRowSelection(values: string[]) {
  return (
    values.reduce(
      (acc, id) => {
        acc[id] = true;
        return acc;
      },
      {} as Record<string, boolean>,
    ) ?? {}
  );
}
